module.exports = __webpack_public_path__ + "img/collaboration-amico.fee8524e.svg";